/**
 * 整行点击时需忽略的交互控件选择器（closest 匹配则不触发行跳转）。
 * 含表格通用控件、AI 工具更多操作、云文档操作按钮等。
 */
export const ROW_CLICK_IGNORE_SELECTOR =
  '.btn-link, .el-checkbox, .el-checkbox__input, .el-dropdown, .notes-list-operator, .ctrl-btn, .meeting-join-link, button, a, input, textarea';
